import React from 'react';

import { Table } from '../../../../components/elements';

const calcPayment = (payment, cfees) => {
  let a;
  let b;

  try {
    a = parseFloat(payment);
    b = parseFloat(cfees);
  } catch {
    // pass
  }

  let value = 0;

  if (Number.isFinite(a)) {
    value += a;
  }

  if (Number.isFinite(b)) {
    value += b;
  }

  return value === 0 ? '-' : `$${parseFloat(value).toFixed(2)}`;
};

const BookingTransactions = ({
  loading,
  transactionData,
  history,
  bookingDateSort,
  setSort,
  setBookingDateSort,
  placeId,
}) => (
  <>
    <Table>
      <thead>
        <tr>
          <th>
            <div>
              <span>Booking Name</span>
            </div>
          </th>
          <th>
            <div>
              <span>Tags</span>
            </div>
          </th>
          <th>
            <span>Booking ID</span>
          </th>
          <th>
            <span>Phone</span>
          </th>
          <th>
            <span>Email</span>
          </th>
          <th>
            <span>
              <a
                onClick={() => {
                  setBookingDateSort(bookingDateSort === 'AES' ? 'DES' : 'AES');
                  setSort(
                    bookingDateSort === 'AES'
                      ? 'BOOKING_DATE_DESC'
                      : 'BOOKING_DATE_ASC',
                  );
                }}
              >
                <i
                  className={
                    bookingDateSort === 'AES'
                      ? 'fas fa-sort-amount-down'
                      : 'fas fa-sort-amount-up'
                  }
                />
              </a>
              Booking Date
            </span>
          </th>
          <th>
            <span>Time</span>
          </th>
          <th>
            <span>Status</span>
          </th>
          <th>
            <span>Table</span>
          </th>
          <th>
            <span>Guests</span>
          </th>
          <th>
            <span>Booking Total</span>
          </th>
          <th>
            <span>C Fee</span>
          </th>
          <th>
            <span>Payout</span>
          </th>
          <th>
            <span>Payment Status</span>
          </th>
          <th>
            <span>Refund Amount</span>
          </th>
        </tr>
      </thead>

      <tbody>
        {transactionData.map(bad => (
          // console.log('');
          <tr key={bad.place_id}>
            <td
              style={{
                cursor: 'pointer',
                color: '#00AEEF',
                whiteSpace: 'nowrap',
              }}
            >
              <span
                onClick={() => {
                  const newTabUrl = `/add-modify-booking/${placeId}/${bad.table_booking_id}`;
                  history.push(newTabUrl);
                }}
              >
                {bad.booking_name}
              </span>
            </td>
            <td style={{}}>
              <span>{!bad.tags ? '-' : bad.tags.join(', ')}</span>
            </td>
            <td style={{ whiteSpace: 'nowrap' }}>
              <span>{bad.booking_reference}</span>
            </td>
            <td style={{ whiteSpace: 'nowrap' }}>
              <span>{bad.phone}</span>
            </td>
            <td style={{ whiteSpace: 'nowrap' }}>
              <span>{bad.email}</span>
            </td>
            <td style={{ whiteSpace: 'nowrap' }}>
              <span>{bad.booking_date}</span>
            </td>
            <td style={{ whiteSpace: 'nowrap' }}>
              <span>{bad.booking_time}</span>
            </td>
            <td style={{ whiteSpace: 'nowrap' }}>
              <span>{bad.booking_status}</span>
            </td>
            <td style={{ whiteSpace: 'nowrap' }}>
              <span>{bad.table_number}</span>
            </td>
            <td style={{ whiteSpace: 'nowrap' }}>
              <span>{bad.guest_count}</span>
            </td>
            <td style={{ whiteSpace: 'nowrap' }}>
              <span>{calcPayment(bad.payment, bad.c_fees)}</span>
            </td>
            <td style={{ whiteSpace: 'nowrap' }}>
              <span>
                {!bad.c_fees ? '-' : `$${parseFloat(bad.c_fees).toFixed(2)}`}
              </span>
            </td>
            <td style={{ whiteSpace: 'nowrap' }}>
              <span>
                {!bad.payout ? '-' : `$${parseFloat(bad.payout).toFixed(2)}`}
              </span>
            </td>
            <td style={{ whiteSpace: 'nowrap' }}>
              <span>{bad.payment_status}</span>
            </td>
            <td style={{ whiteSpace: 'nowrap' }}>
              <span>
                {!bad?.billing?.refund_amount
                  ? '-'
                  : `-$${Math.abs(
                      parseFloat(bad?.billing?.refund_amount),
                    ).toFixed(2)}`}
              </span>
            </td>
          </tr>
        ))}
        <></>
      </tbody>
    </Table>
    {loading && (
      <span
        style={{
          padding: '1rem',
          color: '#00AEEF',
          fontSize: '18px',
        }}
      >
        Loading...
      </span>
    )}
  </>
);

export default BookingTransactions;
